export default [
  {
    key: 'increasement',
    sortable: true,
    sortField: 'createdAt',
    label: 'label.no',
    thClass: 'w-50px text-center',
    tdClass: 'text-center',
  },
  {
    key: 'name',
    label: 'field.name',
    stickyColumn: true,
    variant: 'light',
  },
  {
    key: 'totalBreakTime',
    label: 'general.total_breaks',
  },
  {
    key: 'breakDuration',
    label: 'general.break_time_duration',
  },
  {
    key: 'actions',
    label: 'general.action',
  },
]
